import { Link } from "react-router-dom";
import { Sparkles, BookOpen, Film, Users, ArrowRight } from "lucide-react";
import { TopNav } from "../components/TopNav";
import { useAuth } from "../context/AuthContext";

export default function LandingPage() {
  const { user } = useAuth();
  const cta = user ? "/dashboard" : "/auth";

  return (
    <div className="mvp-page" data-testid="landing-page">
      <TopNav />
      <header className="mvp-hero">
        <div className="mvp-hero-badge" data-testid="hero-badge">
          <Sparkles size={14} /> AI Story Context Engine
        </div>
        <h1 className="mvp-hero-title">
          Turn one idea into an entire <span className="mvp-accent">anime universe</span>
        </h1>
        <p className="mvp-hero-sub">
          Anim8TV builds your complete story bible — characters, factions, power systems,
          conflicts and story arcs — from a single premise. Powered by Claude AI.
        </p>
        <div className="mvp-hero-ctas">
          <Link to={cta} className="btn-primary mvp-cta" data-testid="hero-get-started-btn">
            Start Creating <ArrowRight size={18} />
          </Link>
        </div>
      </header>

      <section className="mvp-features">
        <div className="mvp-feature-card" data-testid="feature-card-anime">
          <Film size={26} className="mvp-feature-icon anime" />
          <h3>Anime Projects</h3>
          <p>Full episode-one outlines with scene-by-scene beats, ready for production.</p>
        </div>
        <div className="mvp-feature-card" data-testid="feature-card-manga">
          <BookOpen size={26} className="mvp-feature-icon manga" />
          <h3>Manga Projects</h3>
          <p>Opening chapter panel breakdowns with dialogue and visual direction.</p>
        </div>
        <div className="mvp-feature-card" data-testid="feature-card-context">
          <Users size={26} className="mvp-feature-icon novel" />
          <h3>Living Story Bible</h3>
          <p>Interlocking characters, factions, relationships, timelines and power systems.</p>
        </div>
      </section>
    </div>
  );
}
